// CTFFlameManager's moving CP contract: muzzle CP0, flame CP1..30 carrying
// position, radius, density, duration and velocity. No per-particle scene objects.
export class FlamePoints {
    constructor(parameters) { this.parameters = parameters; this.points = new Map(); this.carry = 0; this.next = 1; }
    step(dt, controlPoints, emitting, trace) {
        const p = this.parameters, muzzle = controlPoints.get(0); if (!muzzle) return;
        if (emitting) {
            this.carry += dt * 30;
            while (this.carry >= 1) {
                this.carry--; const id = this.next; this.next = this.next % 30 + 1;
                const direction = muzzle.direction ?? muzzle.basis?.[0] ?? [1, 0, 0], speed = Math.max(0, Math.min(10000, p.speed));
                const inherited = direction.reduce((sum,x,i)=>sum+x*(muzzle.velocity?.[i]??0),0);
                this.points.set(id, { position: [...muzzle.position], velocity: direction.map(x=>x*speed), inherited: direction.map(x=>x*inherited), age: 0, duration: Math.max(.01,Math.min(5,p.life)), radius: 3, density: 1 });
                muzzle.target = id;
            }
        }
        for (const [id,cp] of this.points) {
            cp.age += dt; if(cp.age >= cp.duration) { this.points.delete(id); controlPoints.delete(id); continue; }
            const drag = Math.max(0,1-Math.max(0,p.drag)*dt);
            cp.velocity = cp.velocity.map((x,i)=>x*drag+(i===2 ? -p.gravity*dt : 0));
            cp.inherited = cp.inherited.map(x=>x*drag);
            const next=cp.position.map((x,i)=>x+(cp.velocity[i]+cp.inherited[i]+(i===2?p.up:0))*dt);
            const hit=trace?.(cp.position,next);
            if(hit && hit.fraction < 1) { this.points.delete(id); controlPoints.delete(id); continue; }
            cp.position=next; cp.density=1-.9*cp.age/cp.duration; cp.radius=12*(1+cp.age/cp.duration); controlPoints.set(id,cp);
        }
        muzzle.duration=Math.max(.01,p.life); muzzle.radius=3; muzzle.density=1;
    }
}
